document.addEventListener("DOMContentLoaded", function () {
    const hasHeroImage = document.querySelector(".intro-section-hero-image");
    const sidebar = document.querySelector(".sidebar");

    if (!hasHeroImage) {
        document.querySelectorAll(".single-post-content, .content-holder.no-thumbnail").forEach(element => {
            const mainContentBlock = element.querySelector("#main-content-block");

            if (mainContentBlock && mainContentBlock.firstElementChild && mainContentBlock.firstElementChild.tagName.toLowerCase() === "form") {
                function updateMargin() {
                    if (window.innerWidth >= 992) {
                        element.style.marginTop = "-135px";
                    } else {
                        element.style.marginTop = "";
                    }
                }
                if (sidebar) {
                    function sidebarPosition() {
                        sidebar.style.marginTop = "135px";
                    }
                    sidebarPosition();
                    window.addEventListener("resize", sidebarPosition);
                }

                updateMargin();
                window.addEventListener("resize", updateMargin);

            } else {
                if (sidebar) {
                    function sidebarOnTop() {
                        sidebar.style.marginTop = "";
                    }
                    sidebarOnTop();
                    window.addEventListener("resize", sidebarOnTop);
                }
            }

        });
    }
});
